import * as Factory from 'factory.ts'
import faker from 'faker'

import { EntityFactory } from '@webapp/core/utils/mocks/EntityFactory'
import {
  GlobalSearchResultItem,
  type GlobalSearchResultItemConstructor,
} from './GlobalSearchResultItem'
import { GlobalSearchResultTypes } from '../enums'
import { GlobalSearchResultStatuses } from '../enums/GlobalSearchResultStatusEnum'

const OrderRequestResultItemConstructorFactory =
  Factory.Sync.makeFactory<GlobalSearchResultItemConstructor>({
    type: GlobalSearchResultTypes.ORDER_REQUEST,
    uuid: Factory.each((i) => `uuid-or-${i}`),
    id: Factory.each((i) => `${1000 + i}`),
    label: Factory.each(() => faker.name.findName()),
    metadata: {
      status: GlobalSearchResultStatuses.PENDING_APPROVAL,
      date: faker.date.past().toISOString(),
    },
  })

export const OrderRequestResultItemFactory = EntityFactory(
  GlobalSearchResultItem,
  OrderRequestResultItemConstructorFactory
)

const ExpenseRequestResultItemConstructorFactory =
  Factory.Sync.makeFactory<GlobalSearchResultItemConstructor>({
    type: GlobalSearchResultTypes.EXPENSE_REQUEST,
    uuid: Factory.each((i) => `uuid-er-${i}`),
    id: Factory.each((i) => `${2000 + i}`),
    label: Factory.each(() => faker.name.findName()),
    metadata: {
      status: GlobalSearchResultStatuses.PENDING_APPROVAL,
      date: faker.date.past().toISOString(),
    },
  })

export const ExpenseRequestResultItemFactory = EntityFactory(
  GlobalSearchResultItem,
  ExpenseRequestResultItemConstructorFactory
)

const TravelRequestResultItemConstructorFactory =
  Factory.Sync.makeFactory<GlobalSearchResultItemConstructor>({
    type: GlobalSearchResultTypes.TRAVEL_REQUEST,
    uuid: Factory.each((i) => `uuid-tr-${i}`),
    id: Factory.each((i) => `${3000 + i}`),
    label: Factory.each(() => faker.name.findName()),
    metadata: {
      status: GlobalSearchResultStatuses.PENDING_APPROVAL,
      date: faker.date.past().toISOString(),
    },
  })

export const TravelRequestResultItemFactory = EntityFactory(
  GlobalSearchResultItem,
  TravelRequestResultItemConstructorFactory
)

const PurchaseOrderResultItemConstructorFactory =
  Factory.Sync.makeFactory<GlobalSearchResultItemConstructor>({
    type: GlobalSearchResultTypes.PURCHASE_ORDER,
    uuid: Factory.each((i) => `uuid-po-${i}`),
    id: Factory.each((i) => `${4000 + i}`),
    label: Factory.each(() => faker.company.companyName()),
    metadata: {
      status: GlobalSearchResultStatuses.OPEN,
      date: faker.date.past().toISOString(),
    },
  })

export const PurchaseOrderResultItemFactory = EntityFactory(
  GlobalSearchResultItem,
  PurchaseOrderResultItemConstructorFactory
)

const BillResultItemConstructorFactory =
  Factory.Sync.makeFactory<GlobalSearchResultItemConstructor>({
    type: GlobalSearchResultTypes.BILL,
    uuid: Factory.each((i) => `uuid-bill-${i}`),
    id: Factory.each((i) => `${5000 + i}`),
    label: Factory.each(() => faker.company.companyName()),
    metadata: {
      status: GlobalSearchResultStatuses.PENDING_APPROVAL,
      date: faker.date.past().toISOString(),
      invoiceNumber: null,
    },
  })

export const BillResultItemFactory = EntityFactory(
  GlobalSearchResultItem,
  BillResultItemConstructorFactory
)

const PaymentResultItemConstructorFactory =
  Factory.Sync.makeFactory<GlobalSearchResultItemConstructor>({
    type: GlobalSearchResultTypes.PAYMENT,
    uuid: Factory.each((i) => `uuid-pay-${i}`),
    id: Factory.each((i) => `${6000 + i}`),
    label: Factory.each(() => faker.company.companyName()),
    metadata: {
      status: GlobalSearchResultStatuses.PROCESSING,
      date: faker.date.past().toISOString(),
      vendorPaymentMethod: null,
    },
  })

export const PaymentResultItemFactory = EntityFactory(
  GlobalSearchResultItem,
  PaymentResultItemConstructorFactory
)

const CatalogResultItemConstructorFactory =
  Factory.Sync.makeFactory<GlobalSearchResultItemConstructor>({
    type: GlobalSearchResultTypes.CATALOG_ITEM,
    uuid: Factory.each((i) => `uuid-cat-${i}`),
    id: Factory.each(() => faker.commerce.productName()),
    metadata: { sku: null, vendorName: null },
  })

export const CatalogResultItemFactory = EntityFactory(
  GlobalSearchResultItem,
  CatalogResultItemConstructorFactory
)

const VendorResultItemConstructorFactory =
  Factory.Sync.makeFactory<GlobalSearchResultItemConstructor>({
    type: GlobalSearchResultTypes.VENDOR,
    uuid: Factory.each((i) => `uuid-ven-${i}`),
    id: Factory.each(() => faker.company.companyName()),
    metadata: { isPreferredVendor: false, externalId: null },
  })

export const VendorResultItemFactory = EntityFactory(
  GlobalSearchResultItem,
  VendorResultItemConstructorFactory
)
